<template lang="pug">
  .post-job.gray-bg
    .section(v-if="!allowAddJobOfferStatus.allow && allowAddJobOfferStatus.success")
      .container.has-text-centered
        h3 {{ gettext('Please, fill all data in your profile') }}&nbsp;
        router-link.main-btn.col-white.bg-red(:to="{name: 'Profile'}") {{gettext('Go to profile')}}
    .section(v-if="allowAddJobOfferStatus.allow")
      .container.has-text-centered
        h3 {{ gettext('Post a job') }}
        .job-offer-grid
          .main
            .field.is-horizontal
              label.title {{ gettext('General information') }}
            .field.is-horizontal
              label.label {{ gettext('Type of employment')+'*' }}
              .field-body(@click="validateData('employment_type')")
                ajax-dropdown.wide(
                v-tooltip="{content: errors.field.required, show: tooltip.employment_type}"
                v-model="form.employment_type"
                :labelText="gettext('Choose type of employment')"
                :itemName ="'name'"
                :action="{method: 'receiveEmploymentTypes', params: {lang: getLanguage}}"
                :class="{'is-danger': $v.form.employment_type.$error, 'is-empty': !form.employment_type}"
                )
            .field.is-horizontal.tip
              label.label {{ gettext('National/International')+'*' }}
              .field-body
                .ajax-multiselect
                  multiselect(
                  v-tooltip="{content: errors.field.required, show: tooltip.country_visibility}"
                  :class="{'is-danger': $v.form.country_visibility.$error, 'is-empty': !form.country_visibility}"
                  :selectLabel="''"
                  :placeholder="gettext('Choose National/International')"
                  open-direction="bottom"
                  :options="employeesFromOptions"
                  trackBy="name"
                  label="name"
                  :hideSelected="true"
                  v-model="form.country_visibility"
                  :searchable="false"
                  :max-height="500"
                  :close-on-select="true"
                  )
                label.label.edit
                  .mdi.mdi-comment-question-outline.icon-edit(
                  @mouseover="$set(tooltip, 'national_international', true)"
                  @mouseleave="$set(tooltip, 'national_international', false)"
                  v-tooltip="{content: gettext('Users who will be able to see your vacancy'), show: tooltip.national_international}"
                  )

            .field.is-horizontal(v-if="(form.country_visibility || {}).code === 10")
              .tell-us-block
                label.label.top.placeholder.country-rules
                  router-link(:to="{path: `/countries/${countryIso2}/rules`}" target="_blank") {{ gettext('By inviting people from abroad, you must adhere to the rules of your country') }}

            .field.is-horizontal
              label.label {{ gettext('Country')+'*' }}
              .field-body(@click="validateData('country')")
                ajax-multiselect.wide(
                v-tooltip="{content: errors.field.required, show: tooltip.country}"
                v-model="form.country"
                :labelText="gettext('Choose the country')"
                :itemName ="'name'"
                :class="{'is-danger': $v.form.country.$error, 'is-empty': !form.country}"
                :action="{method: 'receiveCountries', params:{lang: getLanguage, filters: ['for_employer_profile']} }"
                @updated="dropdownSelected('region', 'region', 'category', 'sector', 'responsibilities'), form.region = -1"
                :multiple="false"
                :searchable="true"
                :hideSelected="true"
                :closeOnSelect="true"
                )

            .field.is-horizontal
              label.label {{ gettext('Region')+'*' }}
              .field-body(@click="validateData('region')")
                ajax-multiselect.wide(
                  v-if="(form.country.iso2 && edit) || !edit || edited"
                  :receive="Boolean(form.country.id)"
                  v-tooltip="{content: errors.field.required, show: tooltip. region}"
                  v-model="form.region"
                  :labelText="gettext('Choose the region')"
                  :action="{method: 'receiveRegions', params: {lang: getLanguage, country: form.country.iso2}}"
                  :itemName ="'name'"
                  :class="{'is-danger': $v.form.region.$error, 'is-empty': !form.region }"
                  :disabled="!form.country"
                  :multiple="false"
                  :searchable="true"
                  :hideSelected="true"
                  :closeOnSelect="true"
                )

            .field.is-horizontal
              label.label {{ gettext('Industry')+ '*' }}
              .field-body(@click="validateData('category')")
                ajax-dropdown.wide(
                v-if="(form.country.id && edit) || !edit"
                :receive="!!form.country.id"
                v-tooltip="{content: errors.field.required, show: tooltip.category}"
                v-model="form.category"
                :labelText="gettext('Choose industry')"
                :itemName ="'name'"
                :action="{method: 'receiveCompanyTypes', params:{lang: getLanguage, country: form.country.id}}"
                :class="{'is-danger': $v.form.category.$error, 'is-empty': !form.category }"
                :disabled="!form.country"
                @updated="dropdownSelected('sector', 'sector', 'responsibilities')"
                )

            .field.is-horizontal
              label.label {{ gettext('Sector')+ '*' }}
              .field-body(@click="validateData('sector')")
                ajax-dropdown.wide(
                v-if="(form.category.id && edit) || !edit || edited"
                v-tooltip="{content: errors.field.required, show: tooltip.sector}"
                v-model="form.sector"
                :labelText="gettext('Choose sector')"
                :itemName ="'name'"
                :action="{method: 'receiveCompanySectors', params:{lang: getLanguage, type: form.category.id}}"
                :class="{'is-danger': $v.form.sector.$error, 'is-empty': !form.sector}"
                :disabled="!form.category"
                @updated="dropdownSelected('responsibilities', 'responsibilities')"
                )

            .field.is-horizontal
              label.label {{ gettext('Profession')+ '*' }}
              .field-body(@click="validateData('profession')")
                ajax-dropdown.wide(
                v-if="(form.category.id && edit) || !edit || edited"
                v-tooltip="{content: errors.field.required, show: tooltip.profession}"
                v-model="form.profession"
                :labelText="gettext('Choose sector')"
                :itemName ="'name'"
                :option="gettext('Other')"
                :returnDefault="true"
                :action="{method: 'receiveWorkProfessions', params:{lang: getLanguage, sector: form.sector.id || form.sector}}"
                :class="{'is-danger': $v.form.profession.$error, 'is-empty': !form.profession}"
                :disabled="!form.sector"
                :receive="Boolean(form.sector)"
                )

            .field.is-horizontal(v-if="getUser.profile_type === CONSTANTS.RECEIVER_PROFILE_TYPE")
              label.label {{ gettext('Employer')+'*' }}
              .field-body(@click="validateData('employer')")
                input.input(
                v-tooltip="{content: errors.field.required, show: tooltip.employer}"
                name="employer"
                v-model="form.employer"
                @input="form.employer = validateLatinCharacter($event)"
                :placeholder="gettext('Only latin letters')"
                @blur="validateData('employer')"
                :class="{'is-danger': $v.form.employer.$error, 'is-empty': !form.employer}"
                )

            .field.is-horizontal(v-if="(form.profession || {}).default")
              label.label.name {{ gettext('Other profession')+'*' }}
              .field-body
                input.input(
                name="position"
                v-tooltip="{content: errors.field.required, show: tooltip.other_profession}"
                v-model="form.other_profession"
                @input="form.other_profession = validateLatinCharacter($event)"
                :placeholder="gettext('Only latin letters')"
                @blur="validateData('other_profession')"
                :class="{'is-danger': $v.form.other_profession.$error, 'is-empty': !form.other_profession}"
                )

            .field.is-horizontal
              label.title.border-top {{ gettext('Responsibilities') }}

            .field.is-horizontal
              .tell-us-block
                .field-body
                  textarea.textarea(
                  v-tooltip="{content: errors.field.maxLength(2000), show: $v.form.responsibilities.$error}"
                  :class="{'is-danger': $v.form.responsibilities.$error}"
                  rows="10"
                  v-model="form.responsibilities"
                  @input="form.responsibilities = validateLatinCharacter($event)"
                  :placeholder="gettext('Only latin letters')"
                  @blur="validateData('responsibilities')"
                  )

            .field.is-horizontal
              label.title.border-top {{ gettext('Qualification') }}

            .field.is-horizontal
              .tell-us-block
                .field-body
                  textarea.textarea(
                  v-tooltip="{content: errors.field.maxLength(512), show: $v.form.description.$error}"
                  :class="{'is-danger': $v.form.description.$error}"
                  rows="10"
                  v-model="form.description"
                  @input="form.description = validateLatinCharacter($event)"
                  :placeholder="gettext('Only latin letters')"
                  )

            .field.is-horizontal
              label.title.border-top {{ gettext('Contact information') }}
            .field.is-horizontal
              label.label {{ gettext('Contact person')+ '*' }}
              .field-body
                input.input(
                v-tooltip="{content: errors.field.required, show: tooltip.contact_person}"
                name="contact_person"
                v-model="form.contact_person"
                @input="form.contact_person = validateLatinCharacter($event)"
                :placeholder="gettext('Only latin letters')"
                @blur="validateData('contact_person')"
                :class="{'is-danger': $v.form.contact_person.$error, 'is-empty': !form.contact_person}"
                )
            .field.is-horizontal
              label.label {{ gettext('Phone')+ '*' }}
              .field-body
                v-phone-input(
                name="phone"
                v-tooltip="{content: errors.server.contact_phone || errors.field.required, show: tooltip.contact_phone}"
                v-model="form.contact_phone"
                @blur="validateData('contact_phone')"
                :class="{'is-danger': $v.form.contact_phone.$error, 'is-empty': !form.contact_phone}"
                @onInput="form.contact_phone = $event.number"
                :phone="form.contact_phone"
                )
            .field.is-horizontal
              label.label {{ gettext('Email')+ '*' }}
              .field-body
                input.input(
                v-tooltip="{content: errors.field.required, show: tooltip.contact_email}"
                name="email"
                v-model="form.contact_email"
                @blur="validateData('contact_email')"
                :class="{'is-danger': $v.form.contact_email.$error, 'is-empty': !form.contact_email}"
                :placeholder="$v.form.contact_email.$error ? 'Example: test@gmail.com' : ''"
                )
            .field.is-horizontal
              label.title.border-top {{ gettext('Salary') }}
            .field.is-horizontal
              label.label {{ gettext('Salary') }}*
              .field-body.inline-items
                input.input(
                v-tooltip="{content: $v.form.salary.integer ? errors.field.required : errors.field.integer, show: tooltip.salary}"
                name="salary"
                type="number"
                v-model="form.salary"
                @blur="validateData('salary')"
                :class="{'is-danger': $v.form.salary.$error, 'is-empty': !form.salary}"
                )
                dropdown-simple(:custom="true" :selected="salary_type")
                  a.dropdown-item(v-for="item in salaryTypes" @click="salary_type = item") {{ item.name }}
            .field.is-horizontal
              label.label {{ gettext('Currency') }}*
              .field-body.inline-items
                ajax-dropdown.wide(
                v-tooltip="{content: errors.field.required, show: tooltip.currency}"
                v-model="form.currency"
                :labelText="gettext('Choose currency')"
                :itemName ="'code'"
                :returnItem="'id'"
                :action="{method: 'receiveCurrencies', params: {lang: getLanguage}}"
                :class="{'is-danger': $v.form.currency.$error, 'is-empty': !form.currency}"
                )
            .field.is-horizontal(v-if="[CONSTANTS.EMPLOYER_PROFILE_TYPE, CONSTANTS.RECEIVER_PROFILE_TYPE].indexOf(getUser.profile_type) !== -1")
              label.label {{ gettext('Number of vacancies') }}*
              .field-body.inline-items
                input.input(
                v-tooltip="{content: $v.form.number_of_vacancies.integer ? errors.field.required : errors.field.integer, show: tooltip.number_of_vacancies}"
                name="number_of_vacancies"
                type="number"
                v-model="form.number_of_vacancies"
                @blur="validateData('number_of_vacancies')"
                :min="1"
                :max="200"
                :class="{'is-danger': $v.form.number_of_vacancies.$error, 'is-empty': !form.salary}"
                )
            .field.is-horizontal
              label.label.name {{ gettext('Start date') }}
              .field-body
                datepicker(
                :inputClass="'input'"
                :clearButton="true"
                :offset="1"
                :minAge="0"
                :maxAge="2"
                v-model="form.start_date")

            .field.is-horizontal
              label.label {{ gettext('Trial period, months') }}
              .field-body
                input.input(
                type="number"
                name="trial_period_mon"
                v-model="form.trial_period_mon"
                min="0"
                )

            .field.is-horizontal
              label.label {{ gettext('Working hours per week')}}
              .field-body
                input.input(
                v-tooltip="{content: $v.form.work_hours_week.integer ? errors.field.required : errors.field.integer, show: tooltip.work_hours_week}"
                name="workingHours"
                type="number"
                min="0"
                v-model="form.work_hours_week"
                @blur="validateData('work_hours_week')"
                :class="{'is-danger': $v.form.work_hours_week.$error, 'is-empty': !form.work_hours_week}"
                )
            .field.is-horizontal(v-if="(form.country_visibility || {}).code !== CONSTANTS.COUNTRY_VISIBILITY_LOCAL")
              label.title.border-top {{ gettext('Additional Information') }}
            .field.is-horizontal(v-if="(form.country_visibility || {}).code !== CONSTANTS.COUNTRY_VISIBILITY_LOCAL")
              label.label {{ gettext('Accept couples') }}
              .field-body.has-text-left
                span.radio-wrap
                  input.is-checkradio#accept-couples-yes(type="radio" name="accept-couples-yes" :value='true' v-model="form.accept_couples")
                  label(for="accept-couples-yes") {{ gettext('Yes') }}
                span.radio-wrap
                  input.is-checkradio#accept-couples-no(type="radio" name="accept-couples-no" :value='false' v-model="form.accept_couples")
                  label(for="accept-couples-no") {{ gettext('No') }}
            .field.is-horizontal(v-if="(form.country_visibility || {}).code !== CONSTANTS.COUNTRY_VISIBILITY_LOCAL")
              label.label {{ gettext('Food provided') }}
              .field-body.has-text-left
                span.radio-wrap
                  input.is-checkradio#foodYes(type="radio" name="food" :value='true' v-model="form.food")
                  label(for="foodYes") {{ gettext('Yes') }}
                span.radio-wrap
                  input.is-checkradio#foodNo(type="radio" name="food" :value='false' v-model="form.food")
                  label(for="foodNo") {{ gettext('No') }}
            .field.is-horizontal(v-if="(form.country_visibility || {}).code !== CONSTANTS.COUNTRY_VISIBILITY_LOCAL")
              label.label {{ gettext('Accommodation provided') }}
              .field-body.has-text-left
                span.radio-wrap
                  input.is-checkradio#accomodationYes(type="radio" name="accomodation" :value='true' v-model="form.accommodation")
                  label(for="accomodationYes") {{ gettext('Yes') }}
                span.radio-wrap
                  input.is-checkradio#accomodationNo(type="radio" name="accomodation" :value='false' v-model="form.accommodation")
                  label(for="accomodationNo") {{ gettext('No') }}

            .field.is-horizontal.field-accom(v-if="form.accommodation && (form.country_visibility || {}).code !== CONSTANTS.COUNTRY_VISIBILITY_LOCAL")
              label.label {{ gettext('Accommodation cost include utilities (EUR)') }}
              .field-body
                input.input(
                type="number"
                min="0"
                name="utilities"
                :disabled="form.accommodation_cost_excl_utilities > 0"
                v-model="form.accommodation_cost_incl_utilities"
                )

            .field.is-horizontal.field-accom(v-if="form.accommodation && (form.country_visibility || {}).code !== CONSTANTS.COUNTRY_VISIBILITY_LOCAL")
              label.label {{ gettext('Accommodation cost exclude utilities (EUR)') }}
              .field-body
                input.input(
                type="number"
                min="0"
                name="utilities"
                :disabled="form.accommodation_cost_incl_utilities > 0"
                v-model="form.accommodation_cost_excl_utilities")

            .radio-block
              .field.is-horizontal
                label.label
                .field-body
                  button.main-btn.col-white.bg-red.btn-big(
                  :disabled="imageLoading"
                  @click="send"
                  v-scroll-to="{ element: '.is-empty', easing: 'linear', offset: -100 }"
                  )
                    span(v-if="!imageLoading") {{ edit ? gettext('Update') : gettext('Publish') }}
                    span(v-else) {{ gettext('Processing...') }}
          .right
            image-cropper(
            ref="imageCropper"
            :cropButtonText="gettext('Crop image')"
            :rotateButtonText="gettext('Rotate')"
            :rotate="true"
            :resize="true"
            :customStrings="{ drag: gettext('Upload image'), change: gettext('Change Photo'), remove: gettext('Remove Photo') }"
            :viewport="{ width: 226, height: 140 }"
            v-model="image"
            @cropped="loadImage",
            @remove="form.image_imgid = ''"
            @update="cropped = !cropped"
            )
</template>

<script>
import Vue from 'vue'
import { gettext, interpolate, ngettext } from '@/services/TranslateHandler'
import { mapGetters, mapActions } from 'vuex'
import AjaxDropdown from '@/components/ajax-dropdown'
import Vuelidate from 'vuelidate'
import { email, required, integer, maxLength, minValue, maxValue } from 'vuelidate/lib/validators'
import AjaxMultiselect from '@/components/ajax-multiselect'
import VTooltip from 'v-tooltip'
import VPhoneInput from '@/components/v-phone-input'
import Datepicker from '@/components/datepicker'
import ImageCropper from '@/components/image-cropper'
import Multiselect from 'vue-multiselect'
import mixin from '@/mixins'
import DropdownSimple from '@/components/dropdown-simple'

const CONSTANTS = require('@/constants.json')
const VueScrollTo = require('vue-scrollto')
const toastr = require('toastr')
const _ = require('lodash')

Vue.use(VTooltip, {
  defaultTrigger: 'manual'
})
Vue.use(VueScrollTo)

Vue.use(Vuelidate)

export default {
  name: 'postJob',
  mixins: [
    mixin
  ],
  components: {
    AjaxDropdown,
    AjaxMultiselect,
    VPhoneInput,
    Datepicker,
    ImageCropper,
    Multiselect,
    DropdownSimple
  },
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo})
  },
  data () {
    return {
      edit: !!this.$route.params.id,
      edited: false,
      tooltip: {},
      CONSTANTS: CONSTANTS,
      image: '',
      cropped: false,
      imageLoading: false,
      countries: [],
      allowAddJobOfferStatus: {},
      salary_type: {},
      form: {
        image_imgid: '',
        salary: '',
        country: '',
        region: '',
        employment_type: '',
        category: '',
        sector: '',
        profession: '',
        other_profession: '',
        experience_time: '',
        languages: [],
        driving_licences: [],
        employer: '',
        height: '',
        contact_person: '',
        contact_phone: '',
        contact_email: '',
        responsibilities: '',
        description: '',
        work_hours_week: '',
        food: true,
        accommodation: true,
        accommodation_cost_incl_utilities: 0,
        accommodation_cost_excl_utilities: 0,
        gender: CONSTANTS.GENDER_NONE,
        accept_couples: false,
        start_date: '',
        trial_period_mon: 0,
        country_visibility: '',
        is_active: true,
        number_of_vacancies: 1,
        currency: {}
      },
      errors: {}
    }
  },
  validations () {
    let profileType = this.getUser.profile_type
    if (profileType === this.CONSTANTS.RECEIVER_PROFILE_TYPE) {
      return {
        form: {
          salary: {required, integer},
          country: {required},
          region: {required},
          employment_type: {required},
          category: {required},
          sector: {required},
          profession: {required},
          employer: {required},
          other_profession: {
            required: function (data, current) {
              if ((current.profession || {}).default && !data.length) return false
              return true
            }
          },
          number_of_vacancies: {required, integer, maxValue: maxValue(200), minValue: minValue(1)},
          contact_person: {required},
          contact_phone: {required},
          contact_email: {required, email},
          responsibilities: {maxLength: maxLength(2000)},
          description: {maxLength: maxLength(512)},
          work_hours_week: {integer},
          is_active: true,
          country_visibility: {required},
          currency: {required}
        }
      }
    } else {
      return {
        form: {
          salary: {required, integer},
          country: {required},
          region: {required},
          employment_type: {required},
          category: {required},
          sector: {required},
          profession: {required},
          other_profession: {
            required: function (data, current) {
              if ((current.profession || {}).default && !data.length) return false
              return true
            }
          },
          number_of_vacancies: {required, integer, maxValue: maxValue(200), minValue: minValue(1)},
          contact_person: {required},
          contact_phone: {required},
          contact_email: {required, email},
          responsibilities: {maxLength: maxLength(2000)},
          description: {maxLength: maxLength(512)},
          work_hours_week: {integer},
          is_active: true,
          country_visibility: {required},
          currency: {required}
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'employerCreateVacancy',
      'employerUpdateVacancy',
      'employerGetVacancy',
      'uploadImage',
      'receiveCountries',
      'allowAddJobOffer',
      'receiveReceiverVacancy',
      'addReceiverVacancy',
      'updateReceiverVacancy',
      'receiveCurrencies'
    ]),
    gettext: gettext,
    ngettext: ngettext,
    interpolate: interpolate,
    clear (...fields) {
      this.edited = true
      for (let item of fields) {
        this.$data['form'][item] = ''
      }
    },
    toogleInfoshow (item) {
      this.$set(this.tooltip, item, true)
      setTimeout(() => {
        this.$nextTick(() => {
          this.tooltip[item] = false
        })
      }, 3000)
    },
    getAllowAddJobOfferStatus () {
      let profileType = this.getUser.profile_type
      if (profileType === this.CONSTANTS.EMPLOYER_PROFILE_TYPE) {
        this.allowAddJobOffer().then(res => {
          this.allowAddJobOfferStatus = res
          if (!this.allowAddJobOfferStatus.allow && this.allowAddJobOfferStatus.reason === 'lack_data_profile') {
            toastr.warning(gettext('Lack of data in profile.'), gettext('Warning!'))
          }
        })
      } else {
        this.allowAddJobOfferStatus.allow = true
      }
    },
    getCountries () {
      this.receiveCountries({lang: this.getLanguage}).then(res => {
        this.countries = res
      })
    },
    formatter (data, child, attr = 'id') {
      if (child) {
        for (let key in data) {
          if (Array.isArray(data[key][child])) {
            _.each(data[key][child], (childItem, k) => {
              if (typeof childItem === 'number') {
                data[key][child][k] = childItem
              } else {
                data[key][child][k] = childItem[attr]
              }
            })
          } else {
            data[key] = data[key][attr]
          }
        }
      } else if (typeof data[0] === 'number') {
        return data
      } else {
        _.each(data, (item, key) => {
          data[key] = item[attr]
        })
      }
      return data
    },
    getFormData: function () {
      let profileType = this.getUser.profile_type
      if (profileType === this.CONSTANTS.RECEIVER_PROFILE_TYPE) {
        return {
          name: this.offerName,
          salary: parseInt(this.form.salary),
          salary_type: this.salary_type.code,
          country: this.form.country.id,
          region: this.form.region.id,
          employment_type: this.form.employment_type.id,
          category: this.form.category.id,
          sector: this.form.sector.id,
          profession: this.form.profession.id || null,
          other_profession: this.form.profession.id ? '' : this.form.other_profession,
          experience_time: (this.form.experience_time || {}).id || null,
          languages: this.form.languages ? this.formatter(this.form.languages) : [],
          driving_licences: this.form.driving_licences ? this.formatter(this.form.driving_licences) : [],
          height: (this.form.height || {}).id || null,
          contact_person: this.form.contact_person,
          contact_phone: this.form.contact_phone,
          contact_email: this.form.contact_email,
          responsibilities: this.form.responsibilities,
          description: this.form.description,
          work_hours_week: parseInt(this.form.work_hours_week) || 0,
          food: this.form.food,
          employer: this.form.employer,
          accommodation: this.form.accommodation,
          accommodation_cost_incl_utilities: parseInt(this.form.accommodation_cost_incl_utilities) ? parseInt(this.form.accommodation_cost_incl_utilities) : 0,
          accommodation_cost_excl_utilities: parseInt(this.form.accommodation_cost_excl_utilities) ? parseInt(this.form.accommodation_cost_excl_utilities) : 0,
          is_active: this.edit ? this.form.is_active : undefined,
          gender: this.form.gender,
          accept_couples: this.form.accept_couples,
          start_date: this.form.start_date || null,
          trial_period_mon: parseInt(this.form.trial_period_mon) || 0,
          image_imgid: this.form.image_imgid,
          country_visibility: (this.form.country_visibility || {}).code,
          number_of_vacancies: parseInt(this.form.number_of_vacancies),
          currency: this.form.currency
        }
      } else {
        return {
          name: this.offerName,
          salary: parseInt(this.form.salary),
          salary_type: this.salary_type.code,
          country: this.form.country.id,
          region: this.form.region.id,
          employment_type: this.form.employment_type.id,
          category: this.form.category.id,
          sector: this.form.sector.id,
          profession: this.form.profession.id || null,
          other_profession: this.form.profession.id ? '' : this.form.other_profession,
          experience_time: (this.form.experience_time || {}).id || null,
          languages: this.form.languages ? this.formatter(this.form.languages) : [],
          driving_licences: this.form.driving_licences ? this.formatter(this.form.driving_licences) : [],
          height: (this.form.height || {}).id || null,
          contact_person: this.form.contact_person,
          contact_phone: this.form.contact_phone,
          contact_email: this.form.contact_email,
          responsibilities: this.form.responsibilities,
          description: this.form.description,
          work_hours_week: parseInt(this.form.work_hours_week) || 0,
          food: (this.form.country_visibility || {}).code !== CONSTANTS.COUNTRY_VISIBILITY_LOCAL ? this.form.food : false,
          number_of_vacancies: parseInt(this.form.number_of_vacancies),
          accommodation: (this.form.country_visibility || {}).code !== CONSTANTS.COUNTRY_VISIBILITY_LOCAL ? this.form.accommodation : false,
          accommodation_cost_incl_utilities: parseInt(this.form.accommodation_cost_incl_utilities) ? parseInt(this.form.accommodation_cost_incl_utilities) : 0,
          accommodation_cost_excl_utilities: parseInt(this.form.accommodation_cost_excl_utilities) ? parseInt(this.form.accommodation_cost_excl_utilities) : 0,
          is_active: this.edit ? this.form.is_active : undefined,
          gender: this.form.gender,
          accept_couples: (this.form.country_visibility || {}).code !== CONSTANTS.COUNTRY_VISIBILITY_LOCAL ? this.form.accept_couples : false,
          start_date: this.form.start_date || null,
          trial_period_mon: parseInt(this.form.trial_period_mon) || 0,
          image_imgid: this.form.image_imgid,
          country_visibility: (this.form.country_visibility || {}).code,
          currency: this.form.currency
        }
      }
    },
    setSalaryType (item) {
      this.salary_type = item
    },
    setFormData (data) {
      if (data.image_urls) {
        this.image = data.image_urls.main
        this.form.image_imgid = data.image_imgid
      }
      _.each(data, (item, key) => {
        if (_.indexOf(Object.keys(this.form), key) !== -1) {
          this.form[key] = item
        }
      })
      if (data.salary_type) this.salary_type = _.find(this.salaryTypes, {code: data.salary_type})
      if (data.country_visibility) {
        this.form.country_visibility = _.find(this.employeesFromOptions, {'code': data.country_visibility})
      }
    },
    validateData (item) {
      if (item) {
        this.$v.form[item].$touch()
        if (this.$v.form[item].$error) {
          this.$set(this.tooltip, item, true)
        }
        setTimeout(() => {
          this.tooltip[item] = false
        }, 3000)
      } else {
        this.$v.$touch()
        let errors = this.$v.form
        _.each(errors, (item, key) => {
          if (!key.includes('$')) {
            if (errors[key].$error) {
              this.$set(this.tooltip, key, true)
            }
          }
        })
        setTimeout(() => {
          _.each(this.tooltip, (item, key) => {
            this.tooltip[key] = false
          })
        }, 3000)
      }
    },
    send () {
      this.validateData()
      this.checkValidation()
      if (this.formIsValid) {
        if (!this.edit) {
          this.createJob()
        } else {
          this.updateJob()
        }
      } else {
        toastr.warning(gettext('Please fill all required fields'), gettext('Warning!'))
      }
    },
    checkValidation () {
      this.$v.$touch()
    },
    createJob () {
      let profileType = this.getUser.profile_type
      if (profileType === this.CONSTANTS.RECEIVER_PROFILE_TYPE) {
        this.addReceiverVacancy({lang: this.getLanguage, data: this.getFormData()}).then(res => {
          this.$router.push({name: 'Dashboard', params: {lang: this.getLanguage}})
        }).catch(err => {
          if ((err.data || {}).form_errors) {
            this.errorProcessor(err.data.form_errors)
            toastr.error(gettext('Validation error!'), gettext('Error!'))
          }
        })
      } else {
        this.employerCreateVacancy({lang: this.getLanguage, data: this.getFormData()}).then(res => {
          this.$router.push({name: 'MyJobs', params: {lang: this.getLanguage}})
        }).catch(err => {
          if ((err.data || {}).form_errors) {
            this.errorProcessor(err.data.form_errors)
            toastr.error(gettext('Validation error!'), gettext('Error!'))
          }
        })
      }
    },
    updateJob () {
      let profileType = this.getUser.profile_type
      if (profileType === this.CONSTANTS.RECEIVER_PROFILE_TYPE) {
        this.updateReceiverVacancy({lang: this.getLanguage, data: this.getFormData(), id: parseInt(this.$route.params.id)}).then(() => {
          this.$router.push({name: 'Dashboard', params: {lang: this.getLanguage}})
        }).catch(err => {
          if ((err.data || {}).form_errors) {
            this.errorProcessor(err.data.form_errors)
            toastr.error(gettext('Validation error!'), gettext('Error!'))
          }
        })
      } else {
        this.employerUpdateVacancy({lang: this.getLanguage, data: this.getFormData(), id: parseInt(this.$route.params.id)}).then(() => {
          this.$router.push({name: 'MyJobs', params: {lang: this.getLanguage}})
        }).catch(err => {
          if ((err.data || {}).form_errors) {
            this.errorProcessor(err.data.form_errors)
            toastr.error(gettext('Validation error!'), gettext('Error!'))
          }
        })
      }
    },
    errorProcessor (error) {
      _.each(error, (item, key) => {
        if (_.has(this.form, key)) {
          this.form[key] = ''
          this.$set(this.errors.server, key, item[0].message)
        }
        this.checkValidation()
      })
    },
    dropdownSelected (watch, ...clear) {
      if (this.form[watch]) {
        this.clear(...clear)
      }
    },
    setErrorsText () {
      this.errors = {
        field: {
          required: gettext('This field is required'),
          integer: gettext('Please enter integers'),
          email: gettext('Please enter your email correctly'),
          maxLength: number => interpolate(ngettext('Max %s character', 'Max %s characters', number), [number])
        },
        server: {}
      }
    },
    loadImage (value) {
      return new Promise(resolve => {
        if (value) {
          this.imageLoading = true
          this.uploadImage({lang: this.getLanguage, img: this.imageNormalize(value), profile: 'joboffer'}).then(res => {
            this.image = res.full_url
            this.form.image_imgid = res.imgid
            this.imageLoading = false
            resolve(res)
          })
        }
      })
    },
    imageNormalize (img) {
      if (img) return img.replace(/.*(,)/, '')
    },
    isSeasonal () {
      return (this.$route.query.type === 'seasonal' && !this.edit)
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage',
      'getUser'
    ]),
    countryIso2 () {
      let countryId = this.getUser.country
      return this.countries.find((e) => {
        if (e.id === countryId) {
          return true
        }
      }).iso2.toLowerCase()
    },
    defaultMetaInfo () {
      return {
        title: 'Bixter | ' + gettext('Post Job'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    },
    employeesFromOptions () {
      return [
        {
          code: this.CONSTANTS.COUNTRY_VISIBILITY_LOCAL,
          name: gettext('Only from local country')
        },
        {
          code: this.CONSTANTS.COUNTRY_VISIBILITY_LOCAL_AND_EU,
          name: gettext('Local + EU countries')
        },
        {
          code: this.CONSTANTS.COUNTRY_VISIBILITY_ALL,
          name: gettext('All countries')
        }
      ]
    },
    salaryTypes () {
      return [
        {
          name: gettext('Per hour'),
          code: CONSTANTS.SALARY_PER_HOUR
        },
        {
          name: gettext('Per day'),
          code: CONSTANTS.SALARY_PER_DAY
        },
        {
          name: gettext('Per week'),
          code: CONSTANTS.SALARY_PER_WEEK
        },
        {
          name: gettext('Per month'),
          code: CONSTANTS.SALARY_PER_MONTH
        }
      ]
    },
    formIsValid: function () {
      return (!this.$v.$invalid)
    },
    offerName: function () {
      return `${(this.form.country || {}).name}, ${(this.form.region || {}).name}, ${(this.form.category || {}).name}, ${(this.form.employment_type || {}).name}`
    }
  },
  watch: {
    getLanguage: function () {
      this.setErrorsText()
    }
  },
  created () {
    this.setSalaryType(this.salaryTypes[0])
    this.getAllowAddJobOfferStatus()
    this.setErrorsText()
    this.getCountries()
    if (this.$route.params.id) {
      let profileType = this.getUser.profile_type
      if (profileType === this.CONSTANTS.RECEIVER_PROFILE_TYPE) {
        this.receiveReceiverVacancy(parseInt(this.$route.params.id)).then(res => {
          this.setFormData(res.job_offer)
        }).catch(() => {
          toastr.error(gettext('Server error!'), gettext('Error!'))
        })
      } else {
        this.employerGetVacancy(parseInt(this.$route.params.id)).then(res => {
          this.setFormData(res.job_offer)
        }).catch(() => {
          toastr.error(gettext('Server error!'), gettext('Error!'))
        })
      }
    } else {
      let data = this.$store.state.user
      this.form.country = data.country
      this.form.contact_person = data.contact_person
      this.form.contact_phone = data.contact_phone
      this.form.contact_email = data.email
      this.form.region = data.region
      if (data.profile_type !== CONSTANTS.RECEIVER_PROFILE_TYPE) {
        this.form.category = data.company_type
      }
    }
  }
}
</script>

<style lang='scss' src='./styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/profile/jobs/job/index.vue